const { REACT_APP_AGOL_EXPERIENCE, REACT_APP_AGOL_FILTER_WIDGET } = process.env

interface Props {
  username: string
  useOfficial: boolean
}

export const AgolExperience = ({ username, useOfficial }: Props) => {
  const baseUrl = `https://experience.arcgis.com/experience/${REACT_APP_AGOL_EXPERIENCE}`

  const filters = JSON.stringify([
    {
      name: 'User Name',
      clauses: useOfficial ? [] : [{ index: 1, values: username, label: username }],
    },
    {
      name: 'Official',
      clauses: useOfficial ? [{ index: 1, values: 1, label: '1' }] : [],
    },
  ])

  const src = `${baseUrl}#${REACT_APP_AGOL_FILTER_WIDGET}=filters:${encodeURIComponent(filters)}`

  return (
    <div className="w-100" style={{ height: 'calc(100vh - 65px)' }}>
      <iframe
        key={`${useOfficial}-${username}`}
        src={src}
        style={{ width: '100%', height: '100%', border: 'none' }}
        allowFullScreen
        allow="geolocation"
      />
    </div>
  )
}
